import { win } from "src/global";
import getUniqueStr from "./get-unique-str";

let dvid = win.localStorage.getItem('UBA_DVID');
if (!dvid) {
  dvid = getUniqueStr();
  win.localStorage.setItem('UBA_DVID', dvid);
}

export default () => dvid;
